import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
};

export const UserTrackingState = createSlice({
  name: "UserTracking",
  initialState,
  reducers: {
    setLoadingUserTracking(state, action) {
      return {
        ...state,
        loading: action?.payload,
      };
    },
  },
});

export const { setLoadingUserTracking } = UserTrackingState.actions;
export default UserTrackingState.reducer;
